import { createContext, useState } from "react";

export interface SearchResultState {}

export const SearchResultContext = createContext<any>(undefined);

const SearchResultProvider = (props: any) => {
  const [result, setResult] = useState(undefined);

  const [searchKey, setSearchKey] = useState(1);
  const resetSearch = () => {
    setSearchKey(searchKey + 1);
  };

  return (
    <SearchResultContext.Provider
      value={{
        result,
        setResult,
        searchKey,
        resetSearch,
      }}
    >
      {props.children}
    </SearchResultContext.Provider>
  );
};

export default SearchResultProvider;
